import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { API_ENDPOINTS } from '../constants/api.constants';
import { ApiResponse } from '../interfaces/api-response.model';
import { Observable } from 'rxjs';
import { QuestionnaireTempRequest, QuestionnaireTempResponse } from '../interfaces/appointment-questionnairetemps.model';

/**
 * 查詢健調表體況暫存紀錄
 */
@Injectable({
  providedIn: 'root',
})
export class AppointmentQuestionnairetempsService {
  http: HttpClient = inject(HttpClient);

   /**
     * 查詢健調表體況暫存紀錄 (CB-021)
     * @param request 查詢檢查相關資料請求
     */
    saveQuestionnaireTemps(request: QuestionnaireTempRequest): Observable<ApiResponse<QuestionnaireTempResponse>> {
      return this.http.post<ApiResponse<QuestionnaireTempResponse>>(
        API_ENDPOINTS.QUESTIONNAIRE_TEMPS,
        request
      );
    }

}
